import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../environments/environment';
import { EmployeeCostImportResult } from '../models/monthly-uploads/employee-cost-import';
import { EmployeeMonthlyCost } from '../models/monthly-uploads/employee-monthly-cost';

@Injectable({ providedIn: 'root' })
export class EmployeeCostImportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/employee-monthly-cost';

  public importExcel(month: number, year: number, currency: number, file: File): Observable<ApiResponse<EmployeeCostImportResult>> {
    const formData = new FormData();
    formData.append('file', file);

    const params = new HttpParams().set('month', String(month)).set('year', String(year)).set('currency', String(currency));

    return this.httpClient.post<ApiResponse<EmployeeCostImportResult>>(`${this.baseUrl}/import-excel`, formData, { params });
  }

  public getAll(month?: number, year?: number, currency?: number): Observable<ApiResponse<EmployeeMonthlyCost[]>> {
    let params = new HttpParams();
    if (month !== undefined) {
      params = params.set('month', String(month));
    }
    if (year !== undefined) {
      params = params.set('year', String(year));
    }
    if (currency !== undefined) {
      params = params.set('currency', String(currency));
    }
    return this.httpClient.get<ApiResponse<EmployeeMonthlyCost[]>>(this.baseUrl, { params });
  }

  public update(command: EmployeeMonthlyCost): Observable<ApiResponse<EmployeeMonthlyCost>> {
    return this.httpClient.put<ApiResponse<EmployeeMonthlyCost>>(this.baseUrl, command);
  }

  public getByPeriod(month: number, year: number, currency: number): Observable<ApiResponse<EmployeeMonthlyCost[]>> {
    const params = new HttpParams().set('month', String(month)).set('year', String(year)).set('currency', String(currency));
    return this.httpClient.get<ApiResponse<EmployeeMonthlyCost[]>>(`${this.baseUrl}/by-period`, { params });
  }

  public getBatchByCodesAndPeriod(command: unknown): Observable<ApiResponse<EmployeeMonthlyCost[]>> {
    return this.httpClient.post<ApiResponse<EmployeeMonthlyCost[]>>(`${this.baseUrl}/batch/by-codes-and-period`, command);
  }
}
